import React from "react";
import styled, { css } from "styled-components";
import { fonts } from "assets/fontStyles";

const LabelWrapper = styled.div`
  text-align: left;
  padding-bottom: 10px;
  position: relative;
  bottom: -10px;
  transition: bottom 0.25s ease-in;
  visibility: hidden;

  ${({ visible }) =>
    visible &&
    css`
      visibility: visible;
      bottom: 0px;
    `}
`;

const StyledLabel = styled.div`
  ${fonts.label};
`;

const Label = ({ visible, label, textAlign }) => (
  <LabelWrapper visible={visible} textAlign={textAlign}>
    <StyledLabel>{label}</StyledLabel>
  </LabelWrapper>
);

export default Label;
